import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [{
    path: routeList.RECOVER_CREDENTIALS_PATH,
    name: routeList.RECOVER_CREDENTIALS_NAME,
    component: () => import('@/views/nonAuthenticated/RecoverCredentials')
},
/* ***********************************************
*                 PRE ACTIVE MODE                *
*********************************************** */
{
	path: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_PATH,
	name: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_NAME,
    props: true,
	component: () => import('@/views/nonAuthenticated/PreActiveMode'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.LOGIN_NAME)
	}
}, {
	path: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_RECOVER_CREDENTIALS_PATH,
	name: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_RECOVER_CREDENTIALS_NAME,
    props: true,
	component: () => import('@/views/nonAuthenticated/PreActiveModeRecoverCredentials'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.LOGIN_NAME)
	}
},
/* ***********************************************
*                        JOIN                    *
*********************************************** */
{
	path: routeList.NON_AUTHENTICATED_JOIN_PATH,
	name: routeList.NON_AUTHENTICATED_JOIN_NAME,
	component: () => import('@/views/nonAuthenticated/join/Join'),
	beforeEnter (to, from, next) {
		next()
	}
}, {
	path: routeList.NON_AUTHENTICATED_JOIN_CREATE_ACCOUNT_PATH,
	name: routeList.NON_AUTHENTICATED_JOIN_CREATE_ACCOUNT_NAME,
	component: () => import('@/views/nonAuthenticated/join/CreateAccount'),
	beforeEnter (to, from, next) {
		next()
	}
}, {
	path: routeList.NON_AUTHENTICATED_JOIN_SELF_ADHESION_PATH,
	name: routeList.NON_AUTHENTICATED_JOIN_SELF_ADHESION_NAME,
	component: () => import('@/views/nonAuthenticated/join/SelfAdhesion'),
	beforeEnter (to, from, next) {
		next()
	}
}]
